import Styled from 'styled-components';

export const Section = Styled.div`
  display: flex;
  justify-content: space-between;
`;
